import React from 'react'
import constants from './util/constants'
import { Dialog, Button } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'

const ModalSendEmail = (props) => {
  return (
    <Dialog onClose={props.closeSendEmail} open={props.open} fullWidth={true} maxWidth={'sm'}>
      <div style={{ margin: '1.5rem' }}>
        <div>{constants.contactSalesText}</div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '1.5rem' }}>
          <a href={`mailto:${constants.contactEmail}`}>
            <EmailIcon style={{ margin: '5px 5px -3px 0', fontSize: '17px' }} />
            {constants.contactEmail}
          </a>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={props.closeSendEmail} color='primary'>
            Accept
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default ModalSendEmail
